<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-5' : 'justify-space-between'"
      class="d-flex"
    >
      <v-card-title
        class="titre-h3 mt-3 mb-3 ml-1"
      >
        Borner le simulateur éco
      </v-card-title>
    </div>

    <BaseMessageServerError v-if="serverError" />
    <div>
      <BaseLoader v-if="loading" />
    </div>
    <div
      v-if="!loading"
      class="d-flex flex-wrap"
    >
      <div
        v-for="(repereEconomique, index) in reperesEconomiques"
        :key="index"
        class="ma-4"
      >
        <v-card
          class="eq-height pr-2 min-width-fixed"
        >
          <CarteSimulateurEco
            :repere-economique="repereEconomique"
            @onEdit="onEdit"
          />
        </v-card>
      </div>
    </div>
    <v-dialog
      v-model="isOpenModalUpdateParametre"
      fullscreen
      persistent
      transition="slide-x-transition"
    >
      <UpdateParametreSimulateurModal
        v-if="isOpenModalUpdateParametre"
        :parametre="itemEnModification.parametre"
        :libelle-graine="itemEnModification.libelleFamilleGraine"
        :libelle-critere="itemEnModification.libelleCritere"
        @close="onCloseUpdateParametre()"
      />
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import CarteSimulateurEco from './components/carte-simulateur-eco.vue'
import UpdateParametreSimulateurModal from './components/modal/update-parametre-simulateur-modal.vue'

export default {
  name: 'SimulateurEcoAdmin',
  components: { BaseLoader, BaseMessageServerError, CarteSimulateurEco, UpdateParametreSimulateurModal },

  data () {
    return {
      loading: false,
      serverError: false,
      isOpenModalUpdateParametre: false,
      itemEnModification: null
    }
  },

  computed: {
    ...mapGetters({
      reperesEconomiques: 'reperesEconomiques/reperesEconomiques'
    })
  },

  created () {
    this.loading = true
    this.getReperesEconomiques()
      .catch(() => {
        this.serverError = true
      })
      .finally(() => {
        this.loading = false
      })
  },

  methods: {
    ...mapActions({
      getReperesEconomiques: 'reperesEconomiques/getReperesEconomiques'
    }),
    onEdit (itemEnModification) {
      this.isOpenModalUpdateParametre = true
      this.itemEnModification = itemEnModification
    },
    onCloseUpdateParametre () {
      this.isOpenModalUpdateParametre = false
      this.itemEnModification = null
    }
  }
}
</script>
 <style lang="scss" scoped>
.min-width-fixed  {
  min-width: 400px;
}
</style>
